
/* eslint-disable global-require */
const Main = r => require.ensure([], () => r(require('./Main')), 'licenses-bundle')
const Form = r => require.ensure([], () => r(require('./Form')), 'licenses-bundle')

export default [
  {
    name: 'license.index',
    path: '/licenses',
    component: Main,
    meta: { requiresAuth: true },
    children: [
      {
        name: 'license.new',
        path: 'create',
        component: Form,
        meta: { requiresAuth: true }
      },
      {
        name: 'license.edit',
        path: ':id/edit',
        component: Form,
        meta: { requiresAuth: true }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/licenses/routes.js